import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { ApiService } from '../../../api-service/api.service';
import { ContractStatus, ContractStatuses } from './contract-status';

@Injectable()
export class ContractStatusesService {
  private statuses: BehaviorSubject<ContractStatus[]> = new BehaviorSubject<ContractStatus[]>(null);
  private status: Observable<ContractStatus> = new Observable<ContractStatus>();

  constructor(private api: ApiService) {}

  getStatuses(): Observable<ContractStatus[]> {
    this.api.post('/_ajax/v1/superadmin/contract/contract-statuses/list', {}).subscribe(
      (next) => {
        const statuses: ContractStatus[] = next.values.map((value) => {
          return ContractStatuses.fromKey(value);
        });
        this.statuses.next(statuses);
      },
      (err) => {
        this.statuses.error(err);
      },
    );
    return this.statuses.asObservable();
  }

  public getStatusForPartner(partnerId: string): Observable<ContractStatus> {
    const key = 'status';
    return this.api.post('/_ajax/v1/superadmin/contract/contract-status/', { partnerId: partnerId }).pipe(
      tap((response) => response[key]),
      share(),
    );
  }
}
